<div id="content" class="allcp-form" ng-controller="SettingController" ng-init="forms()">
	<div ng-include="'modules/company/menus/order_menu.html'"></div>
	<div class="row">
		<div class="panel p2">
			
			<div class="panel-body pr10 pl10">

				<div class="col-md-4"
					ng-if="data.forms.length > 0"
					ng-repeat="item in data.forms | filter:data.term ">
					<div class="well" style="background:#fff;" >
						<strong>{{ item.name }}</strong>
						<hr style="margin:15px 0 !important">
						<a href="/form/{{ item.id }}" style="color:#8da2b3;">Düzenle</a>
						<!-- <a href="/form-tasarla/{{ item.id }}" target="__BLANK" ng-if="item.design" class="text-center" style="color:#8da2b3;">Tasarım Düzenle</a>
						<a href="/form-tasarla/{{ item.id }}" target="__BLANK" ng-if="!item.design" class="text-center" style="color:#8da2b3;">Tasarım Ekle</a> -->
						<a href="#" class="pull-right" style="color:#8da2b3;" ng-click="toggleSelection(item.id);delete('set')" >Sil</a>
					</div>
				</div>

				<div ng-if="data.forms.length == 0">
					<div class="alert alert-default pastel">
						<i class="fa fa-info pr10"></i>
						<strong>
							Kayıtlı formunuz bulunamadı! <a href="/form/yeni">Buraya</a> tıklayarak yeni form oluşturubilirsiniz.
						</strong>
					</div>
				</div>

			</div>
		</div>
	</div>
	<div ng-include="'modules/company/settings/partials/delete.html'"></div>
</div>
